import * as React from 'react';
import classNames from 'classnames';

import { withRouter } from 'react-router-dom';

class Modal extends React.Component {
  state = {
    open: this.props.open,
    secondModal: this.props.secondModal,
  };

  componentWillReceiveProps(next_props) {
    if (next_props.open != this.props.open) {
      this.setState({ open: next_props.open });
    }
  }

  componentDidMount() {
    this._updateModalOpen();
  }

  componentWillUnmount() {
    if (document.querySelector('.modal-backdrop')) {
      document.body.removeChild(document.querySelector('.modal-backdrop'));
    }
  }

  _closeModal = () => {
    // The modal will by default close whenever the user clicks outside it.
    // If you want to force the user to take action within the modal,
    // you can pass in the forceAction prop to prevent this behavior.
    if (!this.props.forceAction) {
      if (this.props.close_to) {
        this.props.history.push(this.props.close_to);
      }
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  };

  _updateModalOpen = () => {
    if (this.state.open && !document.querySelector('.modal-backdrop')) {
      const modalElement = document.createElement('div');
      modalElement.className = 'modal-backdrop';
      document.body.appendChild(modalElement);
    } else if (!this.state.open && document.querySelector('.modal-backdrop')) {
      // if there is this modal is the second modal (layered on top of another modal), we will not remove the backdrop (currently only happening in the ad link test modals)
      if (this.state.secondModal) {
        return;
      }
      document.body.removeChild(document.querySelector('.modal-backdrop'));
    }
  };

  render() {
    this._updateModalOpen();

    const size = this.props.size ? 'modal-dialog modal-' + this.props.size : 'modal-dialog modal-lg';

    return (
      <div
        className={classNames('modal', { 'modal-visible': this.state.open })}
        tabIndex="-1"
        role="dialog"
        onClick={this._closeModal}
      >
        <div className={size} onClick={(e) => e.stopPropagation()}>
          <div data-testid={this.props.testid} className={classNames('modal-content', this.props.classNames)}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Modal);
